/**
 * 動画を遅延読み込み
 * @see https://web.dev/lazy-loading-video/
 */

export default class VideoLazy {
  constructor(_parm) {
    this.arrayElmsLazyVideo = [...document.querySelectorAll('[data-video-lazy]')];
    if (!this.arrayElmsLazyVideo.length) return;
  }

  init() {
    if (!this.arrayElmsLazyVideo.length) return;
    if ('IntersectionObserver' in window) {
      const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (video) {
          if (video.isIntersecting) {
            // <video>のposter属性をPC/SPで出し分ける
            const elmVideo = video.target;
            const ww = window.outerWidth;
            if (ww <= 768 && elmVideo.dataset.posterSm) {
              elmVideo.poster = elmVideo.dataset.posterSm;
            }
            // <source>のsrc属性をPC/SPで出し分ける
            for (let source in elmVideo.children) {
              const elmVideoSource = elmVideo.children[source];
              if (typeof elmVideoSource.tagName === 'string' && elmVideoSource.tagName === 'SOURCE') {
                if (ww <= 768 && elmVideoSource.dataset.srcSm) {
                  elmVideoSource.src = elmVideoSource.dataset.srcSm;
                } else {
                  elmVideoSource.src = elmVideoSource.dataset.src;
                }
              }
            }
            elmVideo.load();
            elmVideo.classList.remove('lazy');
            lazyVideoObserver.unobserve(elmVideo);
          }
        });
      });
      this.arrayElmsLazyVideo.forEach(function (lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  }

}